import LoadOrError from 'components/LoadOrError/LoadOrError'

export default LoadOrError
